import React from 'react';
import { getDefaultTimeFilter } from '../services/config';

export const getTimeFilterText = (timeFilter: string): string => {
  if (!timeFilter || timeFilter === 'all') {
    return 'all data';
  }
  
  const match = timeFilter.match(/^-(\d+)\s+(day|days|week|weeks|month|months|year|years)$/);
  if (match) {
    const [, amount, unit] = match;
    const num = parseInt(amount);
    const normalizedUnit = num === 1 ? unit.replace(/s$/, '') : unit;
    return `last ${num} ${normalizedUnit}`;
  }
  
  return timeFilter.replace(/^-/, 'last ');
};

export const getToggleButtonText = (showAll: boolean, timeFilter: string): string => {
  return showAll ? `Show ${getTimeFilterText(timeFilter)} Only` : 'Show All Data';
};

export const getStatusText = (showAll: boolean, timeFilter: string): string => {
  return showAll ? 'Showing all data' : `Showing ${getTimeFilterText(timeFilter)} only`;
};

export const shouldShowAllByDefault = async (): Promise<boolean> => {
  const defaultFilter = await getDefaultTimeFilter();
  return !defaultFilter || defaultFilter === 'all';
};

export const useConfigBasedTimeFilter = () => {
  const [showAll, setShowAll] = React.useState(false);
  const [timeFilter, setTimeFilter] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(true);
  
  React.useEffect(() => {
    Promise.all([
      shouldShowAllByDefault(),
      getDefaultTimeFilter()
    ]).then(([defaultShowAll, filter]) => {
      setShowAll(defaultShowAll);
      setTimeFilter(filter);
      setIsLoading(false);
    });
  }, []);
  
  return { showAll, setShowAll, timeFilter, isLoading };
};